/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useState } from "react";
import { MobileMenu } from "./mobile_menu";
import { MobileBackDrop } from "./mobile_menu/mobile-backdrop";
import { TopBar } from "./top_bar";
import { useHeaderNavLinks } from "./use-header-nav-links";

const Header = () => {
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const headerNavLinks = useHeaderNavLinks();

    const toggleMobile = () => {
        setShowMobileMenu(!showMobileMenu);
    };

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
            setShowMobileMenu(false);
        }
    };

    return (
        <header className="header">
            <TopBar
                headerNavLinks={headerNavLinks}
                scrollToSection={scrollToSection}
                showMobileMenu={showMobileMenu}
                toggleMobile={toggleMobile}
            />

            <MobileMenu
                headerNavLinks={headerNavLinks}
                scrollToSection={scrollToSection}
                show={showMobileMenu}
            />

            {showMobileMenu && <MobileBackDrop toggleMobile={toggleMobile} />}
        </header>
    );
};

export { Header };
